<template>
  <div class="pb-80">
    <div ref="contentArea">
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'SitterOnboarding',
  watch: {
    // Watch for route changes to update focus
    // If you don't do this, keyboard navigation will be forced into footer links
    $route() {
      this.$nextTick(() => {
        this.scrollToTop();
        this.focusFirstInteractive();
      });
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'auto' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    },
    focusFirstInteractive() {
      const contentArea = this.$refs.contentArea as HTMLElement;
      if (!contentArea) return;

      const firstInteractive = contentArea.querySelector(
        'input, button, a[href], textarea, select, [tabindex="0"]'
      ) as HTMLElement;
      if (firstInteractive) {
        firstInteractive.focus({ preventScroll: true });
      }
    },
  },
};
</script>
